import API from "Services/Api";

interface ResetPassword {
  email: string;
  token: string;
  password: string;
  password_confirmation: string;
}

export const forgotPasswordAPI = async (email: string) => {
  const response = await API.post(`/user/forgot-password`, {
    email,
  });
  return response.data;
};

export const resetPasswordAPI = async (userReset: ResetPassword) => {
  const response = await API.post(`/user/reset-password`, {
    ...userReset,
  });
  return response.data;
};
